import React, { useState } from "react";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="navbar fixed w-full top-0 z-50 py-4 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-2 animate-slide-in-left">
          <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-yellow-400 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xl">CG</span>
          </div>
          <span className="text-white text-2xl font-bold">SERVICE</span>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8 animate-fade-in-up delay-200">
          <button
            onClick={() => scrollToSection("accueil")}
            className="text-white hover:text-orange-400 transition-colors font-medium"
          >
            Accueil
          </button>
          <button
            onClick={() => scrollToSection("services")}
            className="text-white hover:text-orange-400 transition-colors font-medium"
          >
            Services
          </button>
          <button
            onClick={() => scrollToSection("apropos")}
            className="text-white hover:text-orange-400 transition-colors font-medium"
          >
            À propos
          </button>
          <button
            onClick={() => scrollToSection("contact")}
            className="btn-primary text-white px-6 py-2 rounded-full font-semibold relative"
          >
            Contact
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden text-white z-50"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`mobile-menu fixed top-0 right-0 w-64 h-full bg-gray-900 md:hidden z-40 p-8 ${mobileMenuOpen ? "active" : ""}`}
      >
        <div className="flex flex-col space-y-6 mt-20">
          <button
            onClick={() => scrollToSection("accueil")}
            className="text-white hover:text-orange-400 transition-colors text-lg font-medium text-left"
          >
            Accueil
          </button>
          <button
            onClick={() => scrollToSection("services")}
            className="text-white hover:text-orange-400 transition-colors text-lg font-medium text-left"
          >
            Services
          </button>
          <a
            href="/realisations"
            className="text-white hover:text-orange-400 transition-colors text-lg font-medium text-left"
          >
            Réalisations
          </a>
          <button
            onClick={() => scrollToSection("apropos")}
            className="text-white hover:text-orange-400 transition-colors text-lg font-medium text-left"
          >
            À propos
          </button>
          <button
            onClick={() => scrollToSection("contact")}
            className="btn-primary text-white px-6 py-3 rounded-full font-semibold text-center relative"
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
